import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {GlobalDataService} from '../app/modules/housekeeping/services/global-data.service'
import {EmitterService} from '../app/modules/housekeeping/services/emitter.service'
import {Subscription} from 'rxjs/Subscription';

declare var _uiq: any;

@Injectable()
export class RoleGuardService implements CanActivate {
    constructor(private router: Router, private _dataService: GlobalDataService, private _emitterService: EmitterService) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        /* below 2 lines for Redirect to calling url after successful login*/
        this._dataService.redirectUrl = state.url;

        if (this._dataService.subscriptions) {
            this._dataService.subscriptions.forEach((subscription: Subscription) => {
                subscription.unsubscribe();
            });
            this._dataService.count = 0;
        }

        if (sessionStorage.getItem("uuid") == null && localStorage.getItem("uuid") != null) {
            sessionStorage.setItem("uuid", localStorage.getItem("uuid"));
            sessionStorage.setItem("token", localStorage.getItem("token"));
            sessionStorage.setItem("user", localStorage.getItem("user"));
            sessionStorage.setItem('userId', localStorage.getItem('userId'));
            sessionStorage.setItem('roleId', localStorage.getItem('roleId'));
            sessionStorage.setItem('expirytime', localStorage.getItem('expirytime'));
            this._emitterService.setloadHeader(true)
        }
        if (sessionStorage.getItem("uuid") != null && localStorage.getItem("uuid") == null) {
            sessionStorage.clear()
        }

        if (sessionStorage.getItem('user')) {
          const u = JSON.parse(sessionStorage.getItem('user'));
          let multiDealer = 'n';
          let dealerCode = '';
          let dealerName = '';
          let dealerRegion = '';
          let dealerCodes='';
          let dealerCollection='';
          if (null != u.dealers) {
            if (u.dealers.length > 1) {
              multiDealer = 'y';
              for(var x of u.dealers){
                dealerCodes+=x.globalCode;
                dealerCollection+=x.name;
                if(u.dealers.indexOf(x) != (u.dealers.length-1)){
                    dealerCodes+=',';
                    dealerCollection+=',';
                }
              }
            }
            const firstDealer = u.dealers[0];
            dealerCode = firstDealer.globalCode;
            dealerName = firstDealer.name;
            dealerRegion = firstDealer.regionCode;
          }
/*
          //_uiq.invoked
          _uiq.push(['identify', u.userId, {
            account_name: dealerName,
            account_id: dealerCode,
            signup_date: null == u.dateEntered ? '' : u.dateEntered.toString().substring(0, 10),
            user_email: u.username,
            user_id: u.userId,
            user_name: (null == u.firstName ? '' : u.firstName) + ' ' + (null == u.lastName ? '' : u.lastName),
            user_first_name: u.firstName,
            user_last_name: u.lastName,
            multi_dealer: multiDealer,
            region: dealerRegion,
            account_ids:dealerCodes,
            account_names:dealerCollection
          }]);

          _uiq.push(['startTracker']);

 */
          // User available so return true
            return true;
        }
        else {
            // not logged in so redirect to login page
            sessionStorage.clear();
            localStorage.clear();
            this._emitterService.setloadHeader(false);
            this.router.navigate(['login'],{queryParams:{'redirectURL':state.url}});

            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/role-guard.service.ts